import React from 'react'
import { Progress } from "antd";
import './Progressbar.css'
const ProgressBar = ({ heading , percent }) => {
  return (

    <div className="ProfileText">
      {heading}
      <div className="custom-progress-container">
        <Progress
          strokeColor="#118936"
          format={() => ""}
          percent={percent}
        />
        
      </div>
    </div>
  )
}

export default ProgressBar